import _ from "lodash";
import { agentstatusListAction } from "../slices/agent-status/agent-status";
import { mapChannels } from "../../components/main_layout/navigation/settings/general_settings/agent_status/constant";

export const agentStatusDetails = (agentresultdata: any) => {
  const agentmappeddata = [];
  for (let agentdata of agentresultdata) {
    agentmappeddata.push({
      aid: agentdata?.aid,
      statusName: agentdata?.statusName,
      type: agentdata?.type,
      description: agentdata?.description,
      domainId: agentdata?.domainId,
      // channels: mapChannels(agentdata),
      channels: agentdata.channels,
      colorCode: agentdata?.colorCode,
    });
  }
  return agentmappeddata;
};

export const agentSearchData = (data: any, text: any) => {
  let searchText = text?.toLowerCase();
  let searchResp = _.filter(data, (data: any) => {
    let name = data?.statusName || "";
    return name?.toLowerCase().includes(searchText);
  });
  return searchResp;
};

export const resetFilter = (state: any) => {
  state.agentstatusList = state.agentstatusdata;
};

export const deleteFunction = async (data: any, dispatch: any) => {
  dispatch(agentstatusListAction.isModalOpen(true));
  dispatch(agentstatusListAction.agentstatusFilter(data));
};
